const dateIsValid = (d, m, y) => {
  let date = new Date();
  date.setFullYear(y, parseInt(m) - 1, d);
  return (
    date.getFullYear() == y &&
    parseInt(date.getMonth()) == parseInt(m) - 1 &&
    date.getDate() == d
  );
};

const randomDate = (start, end) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

const normalizeServiceWords = words =>
  words
    // 1. si mantengono lettere, numeri, apostrofi e punti
    .map(s => s.replace(/[^\p{L}0-9'.]/gu, ""))

    // 2. split sull'apostrofo
    .flatMap(s => s.split("'"))

    // 3. rimozione punti tranne nei codici numerici tipo 88.65.1
    .map(s => {
      if (/^\d+(\.\d+)+$/.test(s)) {
        // mantiene i punti nei codici numerici
        return s;
      } else {
        // rimuove i punti nelle parole
        return s.replace(/\./g, "");
      }
    })

    // filtro stringhe vuote
    .filter(s => s.length > 0);

const getMonthFromNumber = month => {
  switch (month) {
    case "01":
      month = "january";
      break;
    case "02":
      month = "february";
      break;
    case "03":
      month = "march";
      break;
    case "04":
      month = "april";
      break;
    case "05":
      month = "may";
      break;
    case "06":
      month = "june";
      break;
    case "07":
      month = "july";
      break;
    case "08":
      month = "august";
      break;
    case "09":
      month = "september";
      break;
    case "10":
      month = "october";
      break;
    case "11":
      month = "november";
      break;
    case "12":
      month = "december";
      break;
    default:
      break;
  }
  return month;
};

const getVerboseValue = (val, numChars) => {
  return val.length > numChars ? val.substr(0, numChars - 1) + "..." : val;
};

const errorTypes = {
  CUSTOM: 1,
  UNABLE_TO_CALL_API: 2,
  STATUS: 3
};

const existsXOnairExceptionType = headers => {
  return headers && headers["x-onair-exception-type"] != null;
};

const getXOnairExceptionType = headers => {
  if (headers && headers["x-onair-exception-type"]) {
    let exceptionType = headers["x-onair-exception-type"];
    let exception = exceptionType.split(/\.(?=[^\.]+$)/);
    if (exception.length > 0) {
      let exceptionName = exception[exception.length - 1];
      if (exceptionName) {
        return exceptionName;
      }
    }
  }
  return null;
};

const existsXOnairExceptionMessage = headers => {
  return headers && headers["x-onair-message"] != null;
};

const getXOnairExceptionMessage = headers => {
  if (headers && headers["x-onair-message"]) {
    let exceptionMsg = headers["x-onair-message"];
    let message = exceptionMsg;
    if (Array.isArray(exceptionMsg)) {
      message = exceptionMsg[0];
    }
    if (message) {
      return message;
    }
  }
  return null;
};
const downloadBlob = (data, fileName, mimeType) => {
  const url = URL.createObjectURL(new Blob([data], { type: mimeType }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
};
const sanitizeFileName = name => {
  return name.replace(/[\\/:*?"<>|]/g, "-").trim();
};
const toErrorPayload = reason => {
  const message = reason?.message ?? "";
  const isHttpError =
    message === "" || message.startsWith("response status is");

  return isHttpError
    ? {
        type: null,
        body: reason?.response?.body ?? null,
        headers: reason?.response?.headers ?? null
      }
    : { type: message, body: null, headers: null };
};
const BOOKING_STEPS = {
  BENEFICIARY: 0,
  OFFICE: 1,
  SERVICE: 2,
  COVERAGE: 3,
  DIAGNOSIS: 4,
  DOCTOR: 5,
  CALENDAR: 6,
  PORTAL_DATE: 7,
  SUMMARY: 8,
  FEEDBACK: 9
};

const EDIT_APPOINTMENT_WIZARD_STEPS = {
  SERVICE: 1,
  DIAGNOSIS: 2,
  DOCTOR: 3,
  CALENDAR: 4,
  PORTAL_DATE: 5,
  MOTIVATIONS: 6
};

export default {
  dateIsValid,
  randomDate,
  normalizeServiceWords,
  getMonthFromNumber,
  errorTypes,
  existsXOnairExceptionType,
  getXOnairExceptionType,
  existsXOnairExceptionMessage,
  getXOnairExceptionMessage,
  getVerboseValue,
  downloadBlob,
  sanitizeFileName,
  toErrorPayload,
  BOOKING_STEPS,
  EDIT_APPOINTMENT_WIZARD_STEPS
};
